import { useEffect, useState } from "react";
import { io } from "socket.io-client";

const socket = io("http://localhost:5000");

const ActivityFeed = ({ userId }) => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (!userId) return;

    const channel = `activity_${userId}`;

    const handleActivity = (data) => {
      setNotifications((prev) => [data, ...prev.slice(0, 9)]); // Keep max 10
    };

    socket.on(channel, handleActivity);
    return () => socket.off(channel, handleActivity);
  }, [userId]);

  return (
    <div className="bg-gray-50 border border-gray-200 p-4 rounded-2xl shadow-md mb-4">
      <h3 className="font-semibold text-lg mb-2">🔔 Activity Feed</h3>
      {notifications.length === 0 ? (
        <p className="text-sm text-gray-500 italic">No notifications yet.</p>
      ) : (
        <ul className="text-sm space-y-2 max-h-64 overflow-y-auto">
          {notifications.map((note, i) => (
            <li key={i} className="p-2 bg-white rounded-md border hover:bg-blue-50 transition">
              {note.type === "like" && `👍 Someone liked your post`}
              {note.type === "comment" && `💬 New comment: "${note.text}"`}
              {note.type === "mention" && `📣 You were mentioned: "${note.text}"`}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ActivityFeed;